import i from"styled-components";import{theme as e}from"../../../../../theme.js";const a=i.div`
  display: flex;
  align-items: center;
  gap: ${e.spacing*2}px;
  flex-wrap: wrap;
  .details {
    display: flex;
    flex-direction: column;
    gap: ${e.spacing}px;
    > .displayName {
      margin: 0;
      font-size: 16px;
      font-weight: 700;
      color: ${e.colors.gray[900]};
    }
  }
`;export{a as Container};
